export const formGroup = {
    name: {value: null, mandatory: true},
    nik: {value: null, mandatory: true},
    address: {value: null, mandatory: true},
    provinceId: {value: null, mandatory: true},
    kabkotId: {value: null, mandatory: true},
    kecamatanId: {value: null, mandatory: true},
    kelurahanId: {value: null, mandatory: true},
    zipcode: {value: null, mandatory: true},
    gender: {value: null, mandatory: true},
    job1: {value: null, mandatory: true},
    job2: {value: null},
    religion: {value: null, mandatory: true},
    hpNumber1: {value: null, mandatory: true},
    hpNumber2: {value: null},
    email: {value: null, mandatory: true},
    facebook: {value: null},
    instagram: {value: null},
    linkedin: {value: null},
    twitter: {value: null},
    tiktok: {value: null},
    discCategory: {value: null},
    hobby: {value: []},
    interest: {value: []},
    customerId: {value: null},
    memberLevel: {value: null},
    loyaltyLevel: {value: null},
    specialCategory: {value: null},
    specialNotes: {value: null},
    photoCustomerUrl: {value: null},
    kodeCabang: {value: null},
    prospectDate: {value: null},
    prospectId: {value: null},
    category: {value: null, mandatory: true},
    source: {value: null, mandatory: true},
    sourceCabang: {value: null},
    lastFollowUpBy: {value: null},
    type: {value: null},
    prospectOwnership: {value: null},
    lastSeller: {value: null},
};